import * as yup from 'yup';
export const AddGameAccountSchema = yup.object().shape({
  in_game_name: yup.string().required('In-Game name is required!'),
});
